export function lightenColourTowardsWhite(colour, percentage)
{
    // Validate hex colour string
    if (typeof colour !== 'string' || !/^#?[0-9a-fA-F]{6}$/.test(colour)) {
        return colour; // Return original if invalid
    }
    // Validate percentage
    if (typeof percentage !== 'number' || percentage < 0 || percentage > 1) {
        return colour; // Return original if invalid
    }

    const lightColour = Number.parseInt(colour.replace('#', ''), 16);
    const r = (lightColour >> 16) & 0xFF;
    const g = (lightColour >> 8) & 0xFF;
    const b = lightColour & 0xFF;
    const maxCol = 255;
    const newR = r + Math.floor((maxCol - r) * percentage);
    const newG = g + Math.floor((maxCol - g) * percentage);
    const newB = b + Math.floor((maxCol - b) * percentage);
    const padLength = 6;
    return "#" + ((newR << 16) | (newG << 8) | newB).toString(16).padStart(padLength, '0');
}